import React from "react";
import "./LpPartners.css";
const LpPartnersHead = () => {
  return (
    <div className="lpPartnersHead-container">
      <div className="lpPartnersHead-content">
        <h5>Partner</h5>
      </div>
      <h2>
        Our <span>Partners</span>
      </h2>
    </div>
  );
};

export default LpPartnersHead;
